import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { useGetTheme } from '../../../../hooks/useGetTheme';
import s from '../column-title.module.scss';
import IconInfo from '../../../iconInfo';

const ColumnEarnedRewardsTitle = ({ isMobile }) => {
  const colors = useGetTheme();

  const getTextColor = () => ({ style: { color: colors.text } });

  if (isMobile) {
    return (
      <div className={s.colTitle} {...getTextColor()}>
        Earned Rewards
        <Tooltip
          placement='top-start'
          title={
            <div className={s.tooltipMobile}>
              Earned Rewards are those earned and calculated every 24 hours and available to either
              claim and withdrawal or restake and start earning more rewards immediately
            </div>
          }
        >
          <a
            target='_blank'
            rel='noreferrer nofollow noopener'
            href='https://app.mantradao.com/support'
          >
            <IconInfo bg={colors.boringGrey} />
          </a>
        </Tooltip>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span {...getTextColor()} className={s.title}>
          Earned <br /> Rewards
          <Tooltip
            placement='top-end'
            title={
              <div className={s.tooltip}>
                Earned Rewards are those earned and calculated every 24 hours and available to
                either claim and withdrawal or restake and start earning more rewards immediately
              </div>
            }
          >
            <span className={s.tooltipIcon}>
              <IconInfo bg={colors.boringGrey} />
            </span>
          </Tooltip>
        </span>
      </div>
    </div>
  );
};

ColumnEarnedRewardsTitle.propTypes = {
  isMobile: PropTypes.bool,
};

ColumnEarnedRewardsTitle.defaultProps = {
  isMobile: false,
};

export default ColumnEarnedRewardsTitle;
